import * as actionTypes from '../actions/panels/types';

const initialState = {
    quick_info: {isOpen: false, type: '', data: null}
};

const panelsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OPEN_QUICK_INFO: {
            const {type, data} = action.payload;

            return {...state, quick_info: {isOpen : true, type, data}};
        }

        case actionTypes.CLOSE_QUICK_INFO: {
            return {...state, quick_info: {isOpen : false, type : '', data: null}};
        }

        default:
            return state;
    }
}

export default panelsReducer;
